<template>
  <v-card
    tile
    flat
    class="TitleCard"
    :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
  >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-sheet
            class="mb-0"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
          >
            <h2 class="mt-0">{{investorAccount.account_type_display}}</h2>
            <p class="mb-0">MT5 - {{ investorAccount.trading_account_no }}</p>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADEMASTER__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      investorAccount: {},
    };
  },
  computed: {
    ...mapState("tradeMaster", [
      "investorAccounts",
    ]),
  },
  methods: {
    ...mapActions("tradeMaster", [
      TRADEMASTER__ACTIONS.INVESTORACCOUNTS,
    ]),

    investorAccountData() {
      if(this.investorAccounts.length !== 0) {
        return this.investorAccounts.find(
          account => account.id == this.$route.params.id
        ) || {};
      }
    }
  },
  async mounted() {
    await this[TRADEMASTER__ACTIONS.INVESTORACCOUNTS]();
    this.investorAccount = this.investorAccountData();
  },
};
</script>
